<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-input v-model="formInline.batchName" placeholder="卡名称" style="width:220px"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="findBatchInfo">查询</el-button>
                <el-button type="success" @click="addBatchInfo">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="cardBatchList" stripe border center :size="GCONFIG.styleTableSize" v-show="!showDialog">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="batchName" label="卡名称" width="120"></el-table-column>
            <el-table-column prop="title" label="批次" width="110"></el-table-column>
            <el-table-column prop="orderSourceName" label="售卖渠道" width="80"></el-table-column>
            <el-table-column prop="totalCount" label="生成数量" width="80"></el-table-column>
            <el-table-column prop="cardPromotionName" label="关联卡商品单品" width="160"></el-table-column>
            <el-table-column prop="productPromotionName" label="关联实物商品促销" width="160">
                <template slot-scope="scope">
                    <span v-if="scope.row.productPromotionName != null && scope.row.productPromotionName != ''" class="order-main-num" @click="handlePromotion(scope.row)">{{scope.row.productPromotionName}}</span>
                    <span v-else>无</span>
                    <el-tooltip class="item" effect="dark" content="点击跳转页面查看促销详情" placement="top-start">
                            <p class="el-icon-question"></p>
                        </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="deliverCount" label="配送次数" width="80"></el-table-column>
            <el-table-column prop="proCount" label="每次几件" width="80"></el-table-column>
            <el-table-column prop="cardPrice" label="卡总额" width="80"></el-table-column>
            <el-table-column prop="perPrice" label="每次配送金额" width="80"></el-table-column>
            <el-table-column prop="cardType" label="卡类型" width="80">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.cardType==1" effect="plain">奶卡</el-tag>
                    <el-tag size="mini" v-if="scope.row.cardType==2" type="success" effect="plain">咖啡卡</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="320">
                <template slot-scope="scope">
                    <el-button type="warning" size="mini" @click="handleUpdate(scope.row)">修改</el-button>
                    <el-button type="warning" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                    <el-button type="success" size="mini" @click="handlePic(scope.row)">上传图片</el-button>
                    <el-button type="success" size="mini" @click="handleView(scope.row)">查看</el-button>
                    <el-button type="success" size="mini" @click="handleAddMore(scope.row)">追加</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap" v-show="!showDialog">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>

        <!-- 新增/修改 -->
        <el-dialog title="新增批次" :visible.sync="dialogFormVisible" center  center top="5vh">
            <el-form :model="form" label-width="120px" size="small ">
                <el-form-item label="说明">
                    <el-alert title="水牛奶卡类似于认养一头牛，购买卡激活后，就可以选择固定时间间隔长期配送。" type="success" :closable="false">
                    </el-alert>
                </el-form-item>
                <el-form-item label="批次" :required="true">
                    <el-input v-model="form.title" placeholder="批次" clearable></el-input>
                    <span style="color: red">简要说明这一批卡的用途、售卖渠道等</span>
                </el-form-item>
                <el-form-item label="卡名称" :required="true">
                    <el-input v-model="form.batchName" placeholder="卡名称" clearable></el-input>
                </el-form-item>
                <el-form-item label="售卖渠道">
                    <el-select v-model="form.orderSource" placeholder="请售卖渠道">
                        <el-option label="微信购卡" value=26></el-option>
                        <el-option label="天猫" value=28></el-option>
                        <el-option label="京东pop" value=29></el-option>
                        <el-option label="渠道" value=30></el-option>
                        <el-option label="京东自营" value=31></el-option>
                        <el-option label="第三方渠道" value=32></el-option>
                        <el-option label="第三方战略" value=33></el-option>
                        <el-option label="门店" value=34></el-option>
                        <el-option label="抖店自定义奶卡" value=42></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 26 && form.orderSource != 42" label="生成卡数量" :required="true">
                    <el-input v-model="form.totalCount" placeholder="生成卡数量" clearable></el-input>
                    <span style="color: red">请填写1-10000</span>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="关联卡" :required="true">
                    <el-select  v-model="form.cardPromotionId" clearable>
                        <el-option v-for="item in cardPromotionData"
                                   :key="item.promotionId"
                                   :label="item.promotionName"
                                   :value="item.promotionId">
                        </el-option>
                    </el-select>
                    <span style="color: red">对应的卡商品，微信渠道需要选择，其他渠道可以任意选一个。</span>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="关联商品" :required="true">
                    <el-select  v-model="form.productPromotionId" clearable @change="handleItemChange">
                        <el-option v-for="item in productPromotionData"
                                   :key="item.promotionId"
                                   :label="item.promotionName"
                                   :value="item.promotionId">
                        </el-option>
                    </el-select>
                    <span style="color: red">实物商品，最终寄给用户的商品。</span>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="配送次数" :required="true">
                    <el-input-number v-model="form.deliverCount" @change="handleChange" :min="1" :max="100" label="配送次数"></el-input-number>
                    <!--<el-input v-model="form.deliverCount" placeholder="配送次数" clearable @blur="inputBlur(form.deliverCount)"></el-input>-->
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="每次几件" :required="true">
                    <el-input-number v-model="form.proCount" @change="handleChange" :disabled="true" value="1" label="每次几件"></el-input-number>
                    <!--<el-input v-model="form.proCount" placeholder="每次几件" clearable @blur="inputBlur(form.proCount)"></el-input>-->
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="卡总额" :required="true">
                    <el-input v-model="form.cardPrice" placeholder="卡总额" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="每次配送金额" :required="true">
                    <el-input v-model="form.perPrice" placeholder="每次配送金额" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item v-if="form.orderSource != 42" label="卡类型">
                    <el-select v-model="form.cardType" :disabled="allowEdit" placeholder="请选择卡类型">
                        <el-option v-for="item in cardTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="updateOrAddBatch()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 查看卡详情 -->
        <el-dialog  title="卡领取详情" :visible.sync="dialogFormVisible1" center :fullscreen="true">
            <el-form :inline="true" :model="formInline1" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
                <el-form-item label="卡ID">
                    <el-input v-model="formInline1.cardId" placeholder="卡ID"></el-input>
                </el-form-item>
                <el-form-item label="卡密">
                    <el-input v-model="formInline1.cardPassword" placeholder="卡密"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="formInline1.status" clearable filterable>
                        <el-option label="请选择" value="-1"></el-option>
                        <el-option label="未领取" value="0"></el-option>
                        <el-option label="已领取" value="1"></el-option>
                        <el-option label="已激活" value="2"></el-option>
                        <el-option label="暂停" value="3"></el-option>
                        <el-option label="配送中" value="4"></el-option>
                        <el-option label="禁用/退款" value="5"></el-option>
                        <el-option label="已完成" value="6"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="queryCardInfo">查询</el-button>
                    <el-button type="warning" @click="dialogFormVisible1 = false">关闭</el-button>
                    <el-button type="success" @click="handleExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="cardList" stripe border center :size="GCONFIG.styleTableSize"  v-loading="loading1">
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="cardId" label="卡ID"></el-table-column>
                <el-table-column prop="cardPassword" label="卡密"></el-table-column>
                <el-table-column prop="statusName" label="卡状态"></el-table-column>
                <el-table-column prop="createTime" label="兑换时间"></el-table-column>
                <el-table-column prop="usedCount" label="使用数量"></el-table-column>
                <el-table-column prop="nickName" label="兑换用户"></el-table-column>
                <el-table-column label="操作" fixed="right" width="80">
                    <template slot-scope="scope">
                        <el-button type="info" size="mini"
                                   v-if="scope.row.statusName=='未领取' || scope.row.statusName=='已领取' || scope.row.statusName=='已激活' || scope.row.statusName=='暂停' || scope.row.statusName=='配送中'"
                                   @click="disableCard(scope.row.cardId)">禁用</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="formInline1.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline1.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline1.recordsTotal">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {cardBatches,viewCards,addBatch,delBatch,addBatchCards,exportBatch,getProductByProType,getActivePromotionsByActiveType,disabledCardApi} from '@/api/api';
    import uploadComponents from '@/components/upload';
    import {downloadCashticketListApi} from "../../api/api";
    import {baseUrl} from "../../api/http";
    export default {
        data() {
            return {
                showDialog: false,
                dialogFormVisible: false,
                dialogFormVisible1: false,
                cardPromotionData:[],
                productPromotionData:[],
                cardBatchList: [],
                cardList: [],
                promotionPrice : 0,
                loading1 : true,
                cardTypeList:[{id:1,name:'奶卡'},{id:2,name:'咖啡卡'}],
                allowEdit:true,//卡类型是否允许编辑
                added : 0,
                form: {
                    batchId: '',
                    batchName: '',
                    orderSource: '',
                    totalCount: 0,
                    title: '',
                    deliverCount: 1,
                    cardPromotionId:'',
                    productPromotionId:'',
                    proCount:1,
                    cardType:1,
                    cardPrice:0,
                    perPrice:0,
                    batchType:1
                },
                formInline: {
                    platformId: 1,
                    batchId: '',
                    currentPage: 1,
                    pageSize: 10,
                    recordsTotal: 0,
                    batchName:"",
                    batchType:1
                },
                formInline1:{
                    platformId: 1,
                    batchId: '',
                    cardId:'',
                    cardPassword:'',
                    status:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                }
            }
        },
        //挂载时候执行
        mounted(){
            getActivePromotionsByActiveType({activeType:27}).then((res1) => {
                this.cardPromotionData = res1.data.value;
            });
            getActivePromotionsByActiveType({activeType:27}).then((res1) => {
                this.productPromotionData = res1.data.value;
            });
            //初始化首页数据
            this.queryBatchInfo();
        },
        components:{
            uploadComponents
        },
        methods: {
            handleItemChange(data){
                if(data == null || data == ''){
                    this.form.deliverCount = this.form.proCount = 1;
                    this.form.cardPrice = this.form.perPrice = 0;
                    this.promotionPrice = 0;
                    return;
                }
                //价格
                let promotionId = data;
                for(let i = 0 ; i < this.productPromotionData.length ; i++){
                    if(promotionId == this.productPromotionData[i].promotionId){
                        this.promotionPrice = this.productPromotionData[i].promotionPrice;
                        this.form.perPrice = this.promotionPrice * this.form.proCount;
                        //计算总价cardPrice
                        this.form.cardPrice = this.form.perPrice * this.form.deliverCount;
                    }
                }
            },
            handleChange(){
                //计算总价cardPrice
                this.form.perPrice = this.promotionPrice * this.form.proCount;
                this.form.cardPrice = this.form.perPrice * this.form.deliverCount;
            },
            queryBatchInfo(){
                cardBatches(this.formInline).then((res) => {
                    if (res.data.status == 200) {
                        this.formInline.recordsTotal = res.data.value.total;
                        this.cardBatchList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            queryCardInfo(){
                this.loading1 = true;
                viewCards(this.formInline1).then((res) => {
                    this.loading1 = false;
                    if (res.data.status == 200) {
                        this.formInline1.recordsTotal = res.data.value.total;
                        this.cardList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            //查询按钮
            findBatchInfo(){
                this.queryBatchInfo();
                this.formInline.currentPage = 1
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.queryBatchInfo();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.queryBatchInfo();
            },
            handleSizeChange1(val) {
                this.formInline1.pageSize = val;
                this.queryCardInfo();
            },
            handleCurrentChange1(val) {
                this.formInline1.currentPage = val;
                this.queryCardInfo();
            },

            //新增事件
            addBatchInfo() {
                this.form = {
                    batchId: '',
                    batchName: '',
                    orderSource: '',
                    totalCount: 0,
                    title: '',
                    cardType:1,
                    deliverCount: 1,
                    cardPromotionId:'',
                    productPromotionId:'',
                    proCount:1,
                    cardPrice:0,
                    perPrice:0,
                    batchType:1
                };
                this.added = 0;
                this.dialogFormVisible = true;
                this.allowEdit=false;
            },
            //确定事件
            updateOrAddBatch() {
                if(this.added == 1){
                    this.$message({
                        showClose: true,
                        message: '已提交请稍后',
                        type: 'error'
                    });
                    return false;
                }
                if(this.form.batchName == "" || this.form.batchName == ''){
                    this.$message({
                        showClose: true,
                        message: '请填写标题',
                        type: 'error'
                    });
                    return false;
                }
                if(this.form.orderSource != 42 && this.form.cardPromotionId == null){
                    this.$message({
                        message:"请选择商品",
                        type:'error'
                    });
                    return;
                }
                if(this.form.orderSource != 26 && this.form.orderSource != 42 && (this.form.totalCount <= 0 || this.form.totalCount > 10000)){
                    this.$message({
                        message:"请按规则填写生成卡数量",
                        type:'error'
                    });
                    return;
                }

                //判断cardPrice是否等于单品pro的价格
                if(this.form.orderSource != 42){
                    for(var i = 0 ; i < this.cardPromotionData.length ; i++){
                        if(this.form.cardPromotionId == this.cardPromotionData[i].promotionId && this.form.cardPrice < this.cardPromotionData[i].promotionPrice){
                            this.$message({
                                message:"卡商品价格必须大于计算总价",
                                type:'error'
                            });
                            return;
                        }
                    }
                } else {
                    this.form.proCount = 0;
                }

                this.added = 1;
                addBatch(this.form).then((res) => {
                    if(res.data.status != 200){  //不能绑定
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                        this.added = 0;
                    } else {
                        this.queryBatchInfo();
                        this.dialogFormVisible = false;
                    }
                });
            },
            handleUpdate(row){
                this.form = {
                    batchId : row.batchId,
                    batchName : row.batchName,
                    orderSource: "" + row.orderSource,
                    totalCount: row.totalCount,
                    title : row.title,
                    cardType:row.cardType,
                    deliverCount : row.deliverCount,
                    cardPromotionId : row.cardPromotionId,
                    productPromotionId : row.productPromotionId,
                    proCount : row.proCount,
                    cardPrice : row.cardPrice,
                    perPrice : row.perPrice,
                    batchType: row.batchType
                };
                for(let i = 0 ; i < this.productPromotionData.length ; i++){
                    if(this.form.productPromotionId == this.productPromotionData[i].promotionId){
                        this.promotionPrice = this.productPromotionData[i].promotionPrice;
                    }
                }
                this.added = 0;
                this.dialogFormVisible = true;
                this.allowEdit=true;
            },
            handleAddMore(row){
                this.$prompt('请输入数量', '追加卡', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'number'
                }).then(({value}) => {
                    addBatchCards({'batchId': row.batchId,'addCount':value}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryBatchInfo();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '取消输入'
                    // });
                });
            },
            //删除事件
            handleDelete(row){
                this.$confirm('删除此批次, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delBatch({batchId:row.batchId}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.queryBatchInfo();
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {});
            },
            handlePic(row){
                let routerL = '/'+this.$route.path.split('/')[1];
                this.$router.push({path:routerL+'/picture/'+row.batchId,query:{picType:'',picName:row.batchName,picState:'product'}})
            },
            handleExport(){
                window.open(`${baseUrl}/lechun-cms/prepay/exportBatch?batchId=`+this.formInline1.batchId+"&cardId="
                    +this.formInline1.cardId+"&cardPassword="+this.formInline1.cardPassword+"&status="+this.formInline1.status);
            },
            handlePromotion(row){
                if (row.productPromotionId != '') {
                    //跳转促销
                    this.$router.push({
                        path: '/promotionList',
                        query: {promotionId: row.productPromotionId}
                    })
                }
            },
            handleView(row){
                this.dialogFormVisible1 = true;
                this.formInline1.batchId = row.batchId;
                this.formInline1.cardId = '';
                this.formInline1.cardPassword = '';
                this.formInline1.status = '';
                this.cardList = '';
                this.queryCardInfo();
            },
            disableCard(cardId){
                disabledCardApi({"cardId":cardId}).then(res=>{
                    this.loading=false;
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'success'
                        });
                        this.queryCardInfo();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
            // //停用事件
            // handledCancel(row){
            //     this.$confirm('停用此储值卡, 是否继续?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         invalidStorageCard({cardId:row.id,cardState:2}).then((res) => {
            //             if(res.data.status==200){
            //                 this.$message({
            //                     showClose: true,
            //                     message: '成功',
            //                     type: 'success'
            //                 });
            //                 this.queryStorageCardInfo();
            //             }else{
            //                 this.$message({
            //                     showClose: true,
            //                     message: res.data.message,
            //                     type: 'error'
            //                 });
            //             }
            //         })
            //     }).catch(() => {});
            // },
            //
            // //启用事件
            // handledStart(row){
            //     this.$confirm('启用此储值卡, 是否继续?', '提示', {
            //         confirmButtonText: '确定',
            //         cancelButtonText: '取消',
            //         type: 'warning'
            //     }).then(() => {
            //         invalidStorageCard({cardId:row.id,cardState:1}).then((res) => {
            //             if(res.data.status==200){
            //                 this.$message({
            //                     showClose: true,
            //                     message: '成功',
            //                     type: 'success'
            //                 });
            //                 this.queryStorageCardInfo();
            //             }else{
            //                 this.$message({
            //                     showClose: true,
            //                     message: res.data.message,
            //                     type: 'error'
            //                 });
            //             }
            //         })
            //     }).catch(() => {});
            // }
        }
    }
</script>
<style scoped>
    .order-main-num{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/views/prepay/CardBatch.vue